import { axios } from '../util/axios'
import platform from '../util/platform'

const API_ENDPOINT = '/v2/user/passwordless_login'
const API_V3_ENDPOINT = '/v3/user/passwordless_login'

export const passwordlessLoginApiCall = (token, sessionTokens, abTests) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-passwordless'
  return axios
    .post(
      API_ENDPOINT,
      {
        token,
        platform,
        session_ids: sessionTokens,
      },
      {
        withCredentials: true,
        headers: {
          'X-TestAB-Groups': abTests,
        },
      }
    )
    .then(response => response.data)
}

export const passwordlessLoginApiCallRevalidation = (token, sessionTokens) => {
  if (sessionTokens) sessionTokens.policy_type = 'login-passwordless'
  return axios
    .post(
      API_V3_ENDPOINT,
      {
        token,
        platform,
        session_ids: sessionTokens,
      },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)
}
